



























import Vue from 'vue'
import Component from 'vue-class-component'
import { IRadioGroupItem } from '@/interfaces'
// @ts-ignore
import { v4 as uuidv4 } from 'uuid'

@Component({
  props: {
    items: {
      type: Array,
      required: true
    },
    column: {
      type: Boolean,
      default: false
    },
    selected: {
      type: [String, Number, Boolean]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Boolean]
    }
  }
})
export default class RadioGroup extends Vue {
  id: string = 'a' + uuidv4()

  selectItem (item: IRadioGroupItem) {
    this.$emit('input', item.value)
    this.$emit('select', item.value)
  }
}
